import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";

const IndustrialAutomationFeatures = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  // Animation trigger when component enters viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  const styles = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "2rem",
      backgroundColor: "#025261",
      color: "#fff",
      flexWrap: "wrap",
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateY(0)" : "translateY(40px)",
      transition: "all 1s ease-in-out",
    },
    leftSide: {
      flex: 1,
      paddingRight: isMobile ? "0" : "2rem",
      paddingTop: isMobile ? "2rem" : "0",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      order: isMobile ? 2 : 1,
    },
    rightSide: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: isMobile ? "0" : "1rem",
      order: isMobile ? 1 : 2,
    },
    header: {
      fontSize: isMobile ? "1.5rem" : "2rem",
      fontWeight: "bold",
      color: "white",
    },
    paragraph: {
      fontSize: isMobile ? "0.9rem" : "1rem",
      margin: "1rem 0",
      textAlign: "justify",
    },
    list: {
      listStyleType: "none",
      paddingLeft: 0,
    },
    listItem: {
      fontSize: isMobile ? "0.9rem" : "1rem",
      marginBottom: "0.5rem",
      display: "flex",
      alignItems: "flex-start",
    },
    arrow: {
      marginRight: "0.5rem",
      color: "#4CAF50",
      fontSize: isMobile ? "1.2rem" : "1.5rem",
    },
    imageContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: isMobile ? "100%" : "auto",
    },
    image: {
      width: isMobile ? "100%" : "90%",
      maxWidth: "900px",
      height: "auto",
      borderRadius: "8px",
    },
  };

  return (
    <div ref={sectionRef} style={styles.container}>
      {/* Right Side (Image) */}
      <div style={styles.rightSide}>
        <div style={styles.imageContainer}>
          <img
            src="/image/a1.png"
            alt="Industrial Automation Features"
            style={styles.image}
          />
        </div>
      </div>

      {/* Left Side (Text) */}
      <div style={styles.leftSide}>
        <h2 style={styles.header}>
          Advanced Industrial Automation Solutions for Your Business
        </h2>
        <p style={styles.paragraph}>
          Our cutting-edge industrial automation systems streamline operations,
          improve productivity, and enhance safety. We specialize in integrating
          robotics, IoT sensors, and AI-driven control systems to optimize your
          manufacturing and industrial processes.
        </p>
        <ul style={styles.list}>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Tailored automation systems for
            various industries
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Real-time monitoring and
            predictive maintenance
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Integration with AI and machine
            learning technologies
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Energy-efficient and cost-saving
            designs
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Scalable solutions for future
            expansion
          </li>
        </ul>
      </div>
    </div>
  );
};

export default IndustrialAutomationFeatures;
